import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

export default class LightBox {
    constructor() {
        this.init();
    }

    public init = async () => {
        Fancybox.bind("[data-fancybox]", {});
    };
}
